export default __webpack_public_path__ + "static/media/Arimo-Regular.1427de05.ttf";